import { render } from "./ShowLocationComponent.vue?vue&type=template&id=61147702&scoped=true"
import script from "./ShowLocationComponent.vue?vue&type=script&lang=js"
export * from "./ShowLocationComponent.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-61147702"

export default script